export default "__VITE_ASSET__Cl63iKkY__"